export const ErrorFallback = () => (
	<div className="tw:flex tw:h-dvh tw:flex-col tw:items-center tw:justify-center tw:text-center tw:text-2xl tw:text-noComponentGray-text">
		<h2>An error occurred loading the page &#9785;</h2>
		<h3>Please try again</h3>
	</div>
);
